<template>
    <b-modal id="toggleStatus"
             size="lg"
             ref="toggleUserStatusModal"
             class="modal-backdrop"
             no-close-on-esc
             no-close-on-backdrop>
        <template slot="modal-header" class="mx-auto">
            <h5 class="modal-title" style="text-align:center;">{{headerMessage}}</h5>
        </template>
        <template slot="default">
            <p style="background-color:#fae5e3;">
                {{message}}
            </p>
        </template>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button class="um-btn" @click="cancelChanges()">Cancel</b-button>
            <b-button class="um-btn" @click="toggleUserStatus()">{{StatusButtonTxt}}</b-button>
        </template>

        <loading :active.sync="isLoading" :can-cancel="true"></loading>
        <ErrorMessage :errorMessage="error" callbackOnClose></ErrorMessage>
    </b-modal>
</template>
<script>

    //import axios from 'axios';
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    //import { eventbus } from "../../main";
    import ErrorMessage from "./ErrorMessage";
    import service from "../../services/api.services";
    export default {
        name: "ToggleUserStatus",
        components: {
            Loading,
            ErrorMessage
        },
        data() {
            return {

                info: { message: "" },
                isLoading: false,
                error: "",
                UserDisableStatus: false,
                isEnabled: this.userDetail.enabled
            };
        },

        props: {
            headerMessage: String,
            message: String,
            userDetail: {},
            StatusButtonTxt: String,
            isValid: Boolean
        },
       
        methods: {
            cancelChanges: function () {
                this.$bvModal.hide("toggleStatus");
            },
            onStatusChanged: function () {
                this.userDetail.enabled= !this.UserDisableStatus;
                this.isEnabled = !this.UserDisableStatus;
                this.$emit("statusChanged", this.isEnabled);
            },

            toggleUserStatus: function () {
                this.isEnabled = this.userDetail.enabled;
                if (this.isEnabled) {
                    this.UserDisableStatus = true
                }
                else {
                    this.UserDisableStatus = false
                }
                this.updateUserStatus()
            },

            async updateUserStatus() {              
                var that = this

                var userStatusObj = this.PrepareUserStatusObj()
                var statusObj = JSON.stringify(userStatusObj);
                that.isLoading = true;
                service.UpdateUserStatus(statusObj)
                    .then(response => {
                        if (response.data.isStatusChanged == true) {
                            that.isLoading = false;
                            that.$bvModal.hide("toggleStatus");
                            that.onStatusChanged()
                        }
                        else {
                            that.error = "Error occurred while changing user status."
                            that.$bvModal.show("errormessage");
                            that.isLoading = false;
                        }

                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    });

            },

            PrepareUserStatusObj() {
                return {
                    UserName: this.userDetail.userName,
                    FirstName: this.userDetail.firstName,
                    MiddleInitial: this.userDetail.middleInitial,
                    LastName: this.userDetail.lastName,
                    Email: this.userDetail.email,
                    Title: this.userDetail.title,
                    Phone: this.userDetail.phone,
                    StreetAddress: this.userDetail.streetAddress,
                    City: this.userDetail.city,
                    State: this.userDetail.state,
                    PostalCode: this.userDetail.postalCode,
                    Country: this.userDetail.country,
                    SFAccountId: this.userDetail.sfAccountId,
                    SFContactId: this.userDetail.sfContactId,
                    AdfsGUID: this.userDetail.adfsGuid,
                    ProfileId: this.userDetail.profileId,
                    SfUserId: this.userDetail.sfUserId,
                    IsDisabled: this.UserDisableStatus,
                    IsLocked: this.userDetail.isLocked
                };
            },
        }
    }
</script>
<style>
    .requiredinput {
        color: red;
    }

    .hasError label {
        color: red !important;
    }

    .hasError input {
        border-color: red !important;
    }

    .noError input {
        border-color: white !important;
    }

    .modal-backdrop {
        opacity: 0.5;
        transition: opacity 0.2s;
        border-color: red;
    }

    .modal-title {
        margin: auto;
    }

    .errorMessage {
        color: red;
        font-size: 0.8em;
        font-weight: 500;
    }
</style>
